import React, { useEffect, useMemo, useState } from 'react';
import api from '../services/api';
import ReportPrintLayout from '../components/ReportPrintLayout';

const ReportsSalesPrint = () => {
  const getCurrentMonthRange = useMemo(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const toISODate = (d) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    };
    return { start: toISODate(start), end: toISODate(end) };
  }, []);

  const [dateRange, setDateRange] = useState({ start: getCurrentMonthRange.start, end: getCurrentMonthRange.end });
  const [reportData, setReportData] = useState(null);

  const fetchReport = async () => {
    try {
      const res = await api.get('/reports/sales-report', {
        params: { startDate: dateRange.start, endDate: dateRange.end },
      });
      setReportData(res.data);
    } catch (e) {
      setReportData(null);
    }
  };

  useEffect(() => {
    fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange.start, dateRange.end]);

  // Prepare data for the print layout
  const printData = reportData ? {
    summary: {
      total_sales: reportData.summary?.total_sales,
      gross_revenue: reportData.summary?.total_sales,
      net_revenue: reportData.summary?.total_sales,
      total_transactions: reportData.summary?.total_transactions,
      avg_sale_value: reportData.summary?.avg_sale_value,
      profit: reportData.summary?.total_sales * 0.2, // Placeholder
      expenses: reportData.summary?.total_sales * 0.1, // Placeholder
      inventory_value: reportData.summary?.total_sales * 0.3, // Placeholder
    },
    sales_trend: reportData.sales_trend?.map(t => ({
      label: t.date,
      value: t.total_sales
    })),
    weekly_trend: reportData.sales_trend?.map(t => ({
      label: t.date,
      value: t.total_sales
    })),
    monthly_trend: reportData.sales_trend?.map(t => ({
      label: t.date,
      value: t.total_sales
    })),
    revenue_by_service_category: reportData.revenue_by_service_category,
    sales_by_payment_method: reportData.sales_by_payment_method,
    sales_by_branch: reportData.sales_by_branch,
    top_nutritionists: reportData.top_nutritionists,
    detailed_sales: reportData.detailed_sales,
    customer_analysis: {
      new_customers: reportData.summary?.total_transactions,
      returning_customers: Math.floor(reportData.summary?.total_transactions * 0.3),
      avg_lifetime_value: reportData.summary?.total_sales / (reportData.summary?.total_transactions || 1)
    }
  } : null;

  return (
    <ReportPrintLayout
      reportData={printData}
      dateRange={dateRange}
      reportType="sales"
    />
  );
};

export default ReportsSalesPrint;